/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Intercept Product Review Form and send to App

var productreviews = document.getElementById("shopify-product-reviews");
if(document.body.contains(productreviews)){
var x = new MutationObserver(function (e) {
  if (e[0].removedNodes) {
    
    var customer = document.getElementById("rewards_customer");
    if(document.body.contains(customer)){
      var id = customer.value;
      var pid =  document.getElementById('shopify-product-reviews').getAttribute('data-id');
      var form = document.getElementById('new-review-form_'+pid);
      form.addEventListener('submit', (e) => {
      const formData = new FormData(e.target);
      form.setAttribute('action','/apps/rewards/reviews');
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      input.value = id;
      form.appendChild(input);
      form.submit();
	});
    
    } else {
      var fc = document.getElementsByClassName("spr-header")[0];
      var bt = document.getElementsByClassName("spr-summary-actions-newreview")[0];
      bt.setAttribute('style','display: none');
      var el = document.createElement('p');
      el.innerHTML = '<a class="link" href="/account/login">Login</a> to leave a review and earn TMP dollars';
      el.setAttribute('style','margin-top: 5px; background: #fafafa; padding: 10px');
      fc.appendChild(el);
    }
  
  }
});
x.observe(document.getElementById('shopify-product-reviews'), { childList: true });
}

$('.sort-available').on('click', function(){
  $('.unavailable').toggle();
});

$('.wcountry').on('change', function(){
  var selected = $('.wcountry option:selected');
  var s = $('.wcountry option:selected');
  var p = JSON.parse(s[0].getAttribute('data-provinces'));
  $('.wprovince').empty();
  for (var i = p.length - 1; i >= 0; i--) {
      $('.wprovince').append('<option value="'+p[i][0]+'">'+p[i][0]+'</option>');
  }
});


function notifyMe(variantId,element) {
  try{
    var inv = (element != null)? JSON.parse(element.innerHTML) : JSON.parse(document.getElementById("inventory").innerHTML);
  	for(var prod in inv.inventories){
      if (prod == variantId){
      	var qty = inv.inventories[prod].inventory_quantity;
        document.getElementById("notify-me").style.display = (qty <= 0) ? '' : 'none';
        break;
      }
	}
  }catch(e){
  }
    
}

function noitfyVariant(title,id) {
document.getElementById("notify-variant").value = title;
document.getElementById("notify-variant_id").value = id;
}

document.addEventListener('DOMContentLoaded', function(){ 
  var arr = [30698488234115, 30698489413763, 7142923337773, 7372293013549, 7372293046317, 7372293079085, 7372293111853, 7372293144621, 7372293177389, 7372293210157, 7372293242925, 7372293275693, 7372293308461, 7372293341229, 7372293373997, 7372293406765, 7372293439533, 7372293472301, 7372293505069, 7372293537837, 7372293570605, 7372293603373, 7372293636141, 7372293668909, 7372293701677, 7372293734445, 30697642786947, 30698366206083, 30698347004035, 30698354737283, 30698359193731, 7142934839341, 7142936379437, 30698498752643, 7142664601645, 8305661804589, 8305661837357, 8305661870125, 8305661902893, 8305661935661, 8305661968429, 8305662001197, 8305662033965, 8305662066733, 8305662099501, 8305662132269, 8305662165037, 8305662197805, 8305662230573, 8305662263341, 8305662296109, 8305662328877, 8305662361645, 8305662394413, 8305662427181, 8305662459949, 8305662492717, 8305662525485, 8305662558253, 30698491478147, 7372340690989, 7372340723757, 7372340756525, 7142922616877, 7372340527149, 7372340559917, 7372340592685, 7372340625453, 7372340658221, 7372341084205, 7372341116973, 7372341149741, 7372340887597, 7372340920365, 7372340953133, 7372340985901, 7372341018669, 7372341051437, 30698504650883, 30698486497411, 30698477486211];
  var element = document.getElementById("inventory");
  if(document.body.contains(element)){
  var script = JSON.parse($(element).text());
  if(arr.indexOf(script.selected_variant_id) !== -1 ){
    if(document.body.contains(element)){
    } 
  }else {
    var inv = JSON.parse(document.getElementById("inventory").innerHTML);
    notifyMe(inv.selected_variant_id,element);
  }
  }
}, false);

document.addEventListener('variant:changed', function(event) {
  var arr = [30698488234115, 30698489413763, 7142923337773, 7372293013549, 7372293046317, 7372293079085, 7372293111853, 7372293144621, 7372293177389, 7372293210157, 7372293242925, 7372293275693, 7372293308461, 7372293341229, 7372293373997, 7372293406765, 7372293439533, 7372293472301, 7372293505069, 7372293537837, 7372293570605, 7372293603373, 7372293636141, 7372293668909, 7372293701677, 7372293734445, 30697642786947, 30698366206083, 30698347004035, 30698354737283, 30698359193731, 7142934839341, 7142936379437, 30698498752643, 7142664601645, 8305661804589, 8305661837357, 8305661870125, 8305661902893, 8305661935661, 8305661968429, 8305662001197, 8305662033965, 8305662066733, 8305662099501, 8305662132269, 8305662165037, 8305662197805, 8305662230573, 8305662263341, 8305662296109, 8305662328877, 8305662361645, 8305662394413, 8305662427181, 8305662459949, 8305662492717, 8305662525485, 8305662558253, 30698491478147, 7372340690989, 7372340723757, 7372340756525, 7142922616877, 7372340527149, 7372340559917, 7372340592685, 7372340625453, 7372340658221, 7372341084205, 7372341116973, 7372341149741, 7372340887597, 7372340920365, 7372340953133, 7372340985901, 7372341018669, 7372341051437, 30698504650883, 30698486497411, 30698477486211];
  if(arr.indexOf(event.detail.variant.id) !== -1){
  } else {
    notifyMe(event.detail.variant.id);
  	noitfyVariant(event.detail.variant.title,event.detail.variant.title);
  }
});


function wishlist(element,id,handle,action,bid){
  element.setAttribute('disabled', 'disabled');
  var url = '/apps/rewards/wishlist?id='+id+'&handle='+handle+'&act='+action;
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.onload = function() {
    if (xhr.status === 200) {
      
      var response = JSON.parse(xhr.responseText).data;
      
      if(response["action"] == "add"){
         var act = "remove";
      }else{
         var act = "add";
      }
	  
      var el = document.getElementById("wishlist-btn-"+bid);
      var attributes = 'wishlist(this,"'+id+'","'+handle+'","'+act+'")';
      el.setAttribute('onClick',attributes);
      if(response["action"] == "add"){
         el.innerHTML = "Remove from wishlist";
      }else{
         el.innerHTML = "Add to wishlist";
      }
      element.removeAttribute('disabled');
      
      var wishlist = document.getElementById("wishlist");
      if(document.body.contains(wishlist)){
        location.reload()
      }

    } else {
    }
  };
  xhr.send();
}

function customerId(){
  var customer = document.getElementById("rewards_customer");
  if(document.body.contains(customer)){
    return customer.value
  }
}

function fetchCart(){
 
  var customer = document.getElementById("rewards_customer");
  if(document.body.contains(customer)){
  var id = customer.value;
  fetch('/cart.js')
  .then((resp) => resp.json())
  .then(function(data) {
    console.log(data)
    window.cart_token = data.token;
    window.cart_total_price = data.total_price;
    console.log(11)
    rewards(id,data)
  })
  .catch(function(error) {
  }); 
  
  } else {
    return
  }
}

function removeAll(id){
 fetch('/apps/rewards/discount?id='+id+'&act=remove_discount'+'&use_points=false')
  .then((resp) => resp.json())
  .then(function(response) {
  })
  .catch(function(error) {
  });

}

function rewards(id,cart) {
  
  var customer = id;
  
  var url = '/apps/rewards/discount?id='+customer+'&token='+cart.token+'&cart_total='+cart.total_price;
	
  fetch(url)
  .then((resp) => resp.json())
  .then(function(response) {
    
    var rc = document.getElementById("tmp");
    console.log(rc)
    if(document.body.contains(rc)){
      rc.innerHTML = response.data.customer.points;
    };    
    
    if((response.data.customer.points > 0) && (response.data.cart.cart_total <= 50) && response.data.customer.use_points == true ){
      removeAll(id);
      return
    };

    // Show cart Sumamry
    var cn = document.getElementById("summary_target");
    if(document.body.contains(cn)){
      cn.innerHTML = response.html_content;
       showCartNote();
    }

    // Use Points and/or Discount?
    var use_points   = response.data.customer.use_points == true ? true : false,
    	use_discount = response.data.customer.use_discount == true ? true : false;
    
    
    if(response.data.customer.points > 0 && response.data.cart.cart_total >= 100){
      if(use_points && use_discount){
         showRewardsSection(false);
         visitDiscountURL(response.data.discount.code)
      } else if(use_points == false && use_discount == true) {
        showRewardsSection(true);
      }
      else if(use_points) {
        showRewardsSection(false);
        visitDiscountURL(response.data.discount.code)
      } else {
       showRewardsSection(true);
      }
    } else {
    
    };

    updatePointsBtn(response,id);
    var el = document.querySelector('[data-cb]');
    if(use_points == true){
    var v = JSON.parse(response.data.discount.value.total_discount);
	   
    el.innerHTML = '$'+ response.data.cart.cart_total - v.total_discount;
    };
  
  })
  .catch(function(error) {
  }); 
}


function usePoints(value){
  var id = customerId();
  el = document.getElementById('applyPointsBtn');
  el.setAttribute('disabled', 'disabled');
  if(value === true){
  	var url = '/apps/rewards/discount?id='+id+'&act=apply_points'+'&use_points='+value+'&cart_total='+window.cart_total_price;
    
  } else {
  	var url = '/apps/rewards/discount?id='+id+'&act=remove_discount'+'&use_points='+value+'&cart_total='+window.cart_total_price;
  }
  var token = window.cart_token;
  url = url + '&token='+token;
  
  fetch(url)
  .then((resp) => resp.json())
  .then(function(response) {
    
    var switch_tf = response.data.customer.use_points == true ? false : true;
    showRewardsSection(switch_tf)
    document.getElementById("summary_target").innerHTML = response.html_content;
    showCartNote();
    updatePointsBtn(response);
    el.removeAttribute('disabled');
      
  })
  .catch(function(error) {
    el.removeAttribute('disabled');
  });
  
}

function useDiscount(value){

  var input = document.getElementById("discount_code"),
      id = customerId();
  
  if(input.value.length > 0){
   var url = '/apps/rewards/discount?id='+id+'&code='+input.value+'&act=apply_code'+'&cart_total='+window.cart_total_price;
   var token = window.cart_token;
   url = url + '&token='+token;
   
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {

      if(data.data.errors.length > 0){
        $('#myRewards').prepend('<p id="invalid-code" class="pr">Invalid code</p>');
        setTimeout(function(){ 
          $('#invalid-code').remove(); 
        }, 3000);
      } else {
      if(data.data.discount.code === null){
        visitDiscountURL(data.data.discount.combined_discount_code);
      }else{
        visitDiscountURL(data.data.discount.code);
      }
      
      document.getElementById("summary_target").innerHTML = data.html_content;
      $('#myRewards').prepend('<p id="code-applied" class="pr">Code applied</p>');
        setTimeout(function(){ 
          $('#code-applied').remove(); 
        }, 3000);
      }
      
    })
    .catch(function(error) {
    });

  }
}


function visitDiscountURL(code){
  fetch('/discount/'+code)
  .then((resp) => resp.json())
  .then(function(data) {
  })
  .catch(function(error) {
  });  
}
  
function showRewardsSection(value){
  
  var el = document.getElementById("myRewards");
  var action = (value === true)?"Apply":"Remove";
  el.innerHTML = "";
  var newEl = document.createElement('div');
  newEl.innerHTML = '<button id="applyPointsBtn" type="button" class="Button Button Button--primary Button--full" onclick="usePoints('+value+')">'+
					'<span> '+action+' Points</span>'+
          			'<span class="Button__SeparatorDot"></span>'+
         			'<span id="apply-points"></span>'+
        			'</button>';
  ;
  el.appendChild(newEl, el);
    if(action == 'Remove'){
  document.getElementById('applyPointsBtn').classList.add('removePoints');
  }
}

function showCartNote(){
  if(window.tn){
    window.tn._toggleCartNote();
    document.getElementById("five_seconds").classList.add("five_seconds");
    setTimeout(function(){ 
    document.getElementsByClassName("Cart__OffscreenNoteContainer")[0].setAttribute('aria-hidden','true');
    document.getElementById("five_seconds").classList.remove("five_seconds");
    }, 10000);
  }
}

function updatePointsBtn(response,id) {
  
  if(response.data.customer.use_points == true && response.data.cart.cart_total <= 50){
   removeAll(id);
  }
  var pb = document.getElementById("apply-points");
  if(document.body.contains(pb)){
    var pts = response.data.customer.points;
    pb.innerHTML = 'TMP $'+pts;
  }
  visitDiscountURL(response.data.discount.code);
  
  if(response.data.customer.use_points == true){
  var elemm = document.getElementsByClassName('Drawer__Footer')[1];
  var ne = document.createElement('div');
  var sp = document.createElement('span');
  ne.className = 'pa';
  sp.append('Points Applied');
  ne.append(sp);
  elemm.prepend(ne);
  
  setTimeout(function(){ 
    ne.remove(); 
  }, 3000);
  }

}

function referral(id) {
	
  var referrer = id;
  
  if(referrer) {
  
    fetch('/cart/update.js', {
      body: JSON.stringify({ attributes: { referrer: referrer} }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    })
    .then((resp) => resp.json())
    .then(function(data) {
        // Handle response you get from the server
      
      var url = '/apps/rewards/referral?id='+referrer+'&token='+data.token;
   
      fetch(url)
      .then((resp) => resp.json())
      .then(function(data) {
      })
      .catch(function(error) {
      });
      
      
    });
    
  }
  
}

function togglePop(element){
	
  var el = document.getElementById("share-wishlist");
  var v = el.getAttribute('aria-hidden') == "true" ? "false" : "true";
  el.setAttribute('aria-hidden',v)

}

function toggleReferral(element){
	
  var el = document.getElementById("refer-via-email");
  var v = el.getAttribute('aria-hidden') == "true" ? "false" : "true";
  el.setAttribute('aria-hidden',v)

}

function sendEmailReferral(element){
  var email = document.getElementById("email_referral").value;
  var id = element.getAttribute('data-id');
  var formattedBody = 'Hey, \n \n Check out The Modern Playroom at the link below. \n \n https://www.themodernplayroom.com.au?referrer='+id+' \n \n They believe in inspiring creativity in children and promote play through fewer, better toys in design of a creative childhood. \n \n If you spend $50 or more with them, I get TMP$10 added to my Loyalty Program account.';
  var mailToLink = 'mailto:'+email+'?Subject=The Modern Playroom&body=' + encodeURIComponent(formattedBody);
  if(email.length){
	window.location.href = mailToLink;
  }
}

function copyToClipboard(el) {

    // resolve the element
    el = document.getElementById("refer-input");

    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {

        // save current contentEditable/readOnly status
        var editable = el.contentEditable;
        var readOnly = el.readOnly;

        // convert to editable with readonly to stop iOS keyboard opening
        el.contentEditable = true;
        el.readOnly = true;

        // create a selectable range
        var range = document.createRange();
        range.selectNodeContents(el);

        // select the range
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        el.setSelectionRange(0, 999999);

        // restore contentEditable/readOnly to original state
        el.contentEditable = editable;
        el.readOnly = readOnly;
    }
    else {
        el.select();
    }

    // execute copy command
    document.execCommand('copy');
}

function shareWishlist() {
	var form = document.getElementById("share_wishlist_form");
  	data = {}
    data['email'] = document.getElementsByName('email_address')[0].value;
    data['message'] = document.getElementsByName('content')[0].value;
    data['id'] = document.getElementsByName('id')[0].value;
    fetch('/apps/rewards/share_wishlist', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      	'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    })
    .then((resp) => resp.json())
    .then(function(data) {
     var b = document.querySelectorAll('#share_wishlist_form button');
     b[0].innerText = 'SENT';

    })
    .catch(function(error) {
    });   
}

function getQueryParams(){
    try{
        url = window.location.href;
        query_str = url.substr(url.indexOf('?')+1, url.length-1);
        r_params = query_str.split('&');
        params = {}
        for( i in r_params){
            param = r_params[i].split('=');
            params[ param[0] ] = param[1];
        }
      	if(params['referrer'].length > 0){
          return referral(params['referrer'])
      	}
    }
    catch(e){
       return {};
    }
}


function welcome10(code){
  fetch('/discount/'+code)
  .then((resp) => resp.json())
  .then(function(data) {
  })
  .catch(function(error) {
  });  
}

function instaFeed(){
  var arr = [];
  var cells = document.getElementsByClassName('Instafeed__Cell');
  fetch('https://graph.instagram.com/me/media?fields=id,caption,media_url&access_token=IGQVJYS3J2cXhtS1cyeWZAtYzNmMm9nT211ZAGlBSWZAnd1kwOGplNzlCSGh0YUZApdmRkVVJLTlBsUVpTUHViak5mZATZADbTN1QlRURWFzS25rMHp3NmlhYU5sUEhWRDBMMmRlLVlvTGJn')
  .then((resp) => resp.json())
  .then(function(data) {
    var list = data.data;
    for (var i = list.length - 1; i >= 0; i--) {
      var item = '<div class="replaced" data-expand="10" data-bg="\''+list[i].media_url+'\'" aria-label="Open on Instagram" style="background-image: url(\''+list[i].media_url+'\');"></div>'+
                 '<div class="Instafeed__Overlay">'+
                   '<p class="Instafeed__Caption">'+list[i].caption+'</p>'+
                 '</div>';
      if(list[i].media_url.indexOf('//video') == -1){
        arr.push(item)
      }
  	};
    for (var i = cells.length - 1; i >= 0; i--) {
      cells[i].innerHTML = arr[0];
      arr.shift();
      if(cells[i].innerHTML == 'undefined'){
      	cells[i].remove()
      }
    }
    var flkty = new Flickity('.Instafeed');
    flkty.resize();
  })
  .catch(function(error) {
     document.getElementsByClassName('Insta-section')[0].remove();
  }); 
}

document.addEventListener("DOMContentLoaded", function(event) {
fetch('/cart.js')
  .then((resp) => resp.json())
  .then(function(data) {
    console.log(data)
  })
  .catch(function(error) {
  }); 
getQueryParams();
fetchCart();  
var instaEl = document.getElementsByClassName('Instafeed');
if(instaEl.length > 0){
  instaFeed();
};
var customer = document.getElementById("rewards_customer");
if(document.body.contains(customer)){
welcome10('welcome10');
}else {
welcome10('welcome10');
}
  
 $('#notify-form').on('submit', function(e){
   
    e.preventDefault();
   
    data = {}
    data['email'] = document.getElementsByName('email')[0].value;
    data['variant_id'] = document.getElementsByName('variant_id')[0].value;
    data['first'] = document.getElementsByName('first')[0].value;
    data['last'] = document.getElementsByName('last')[0].value;

    fetch('/apps/rewards/notify_me', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
      	'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    })
    .then((resp) => resp.json())
    .then(function(data) {

    if(data.metafield == true){
      $('#form-response').html('<p class="Form__Alert Alert Alert--success">You are already subscribed to this notification.</p>');
    }
    else if(data.errors.length == 0){
      $('#form-response').html('<p class="Form__Alert Alert Alert--success">Thanks! We will notify you when this product becomes available!</p>');
    } else {
      $('#form-response').html('<p class="Form__Alert Alert Alert--error">An error occurred.</p>');
    }

    });
   
  });
  
});